import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { openWhatsApp } from "@/lib/api";

export default function DiscoveryCallFloat() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const footer = document.querySelector("footer[data-testid='footer']");
    if (!footer) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setHidden(entry.isIntersecting),
      { rootMargin: "0px 0px -10% 0px" }
    );
    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.4 }}
          onClick={() =>
            openWhatsApp({
              source: "discovery_call_float",
              message: "Hi CaarSaarthi, I'm not sure which tier fits me. I'd like to book the ₹21 Buyer Consultation to talk it through.",
            })
          }
          className="fixed bottom-5 left-5 md:bottom-8 md:left-8 z-40 rounded-full p-[2px] gradient-bg shadow-[0_10px_40px_-10px_rgba(139,92,246,0.6)] max-w-[92vw]"
          data-testid="discovery-call-float-btn"
          aria-label="Book a ₹21 Buyer Consultation"
        >
          <span className="flex items-center justify-center gap-2 md:gap-3 pl-4 pr-5 md:pl-5 md:pr-6 py-3 md:py-3.5 rounded-full bg-void text-white text-[11px] sm:text-sm font-medium whitespace-nowrap">
            <span>Not sure? Book a Buyer Consultation</span>
            <span className="eyebrow gradient-text !text-xs shrink-0">₹21</span>
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
